import { testUrl } from "../BaseData";

// Sahifaga oid matnlar — translation.json ga bog'liq emas
const LABELS = {
  uz: {
    pageTitle: "Grantlar, loyihalar, memorandumlar",
    tabGrants: "Grantlar",
    tabProjects: "Loyihalar",
    tabMemorandums: "Memorandumlar",
    heroTop: "Renessans",
    heroBottom: "Grants Projects",
    secMemorandums: "Memorandumlar",
    secMemorandumsHint: "Universitetimizning xorijiy oliy ta'lim muassasalari va tashkilotlar bilan hamkorlik kelishuvlari.",
    secGrants: "Grantlar va loyihalar",
    secGrantsHint: "Xalqaro va milliy grant tanlovlari, mahalliy va xalqaro loyihalar, ariza imkoniyatlari va natijalari.",
    secResearch: "Ilmiy tadqiqotlar",
    secResearchHint: "Universitetda olib borilayotgan ilmiy tadqiqotlar, qo'shma loyihalar va ilmiy natijalar.",
    secExchange: "Akademik almashinuv",
    secExchangeHint: "Talabalar va professor-o'qituvchilar uchun xalqaro mobillik dasturlari, stajirovkalar va almashinuv imkoniyatlari.",
    moreInfo: "Batafsil ma'lumot",
    soon: "Tez orada",
    partner: "Hamkor tashkilot",
    date: "Sana",
    download: "Hujjatni yuklab olish",
    visitLink: "Havolaga o'tish",
    emptySection: "Hozircha bu bo'limda ma'lumot yo'q",
    otherItems: "Boshqa yozuvlar",
    students: "Talabalarga",
    teachers: "O'qituvchilarga",
    universities: "Oliy ta'lim universitetlari uchun",
    everyone: "Barchaga",
    studentsHint: "Stipendiya va o'qish grantlari",
    teachersHint: "Stajirovka va tadqiqot grantlari",
    universitiesHint: "Institutsional loyihalar va hamkorlik",
    chooseSection: "Kimlar uchun grant qidiryapsiz?",
    grantCount: (n) => `${n} ta grant`,
    open: "Ko'rish",
    backToSections: "Bo'limlarga qaytish",
    international: "Xalqaro",
    local: "Mahalliy",
    funding: "Moliyalash",
    deadline: "Oxirgi muddat",
    daysLeft: (n) => `${n} kun qoldi`,
    lastDay: "Bugun oxirgi kun",
    expired: "Muddati tugagan",
    noDeadline: "Muddat belgilanmagan",
    loading: "Yuklanmoqda...",
    error: "Ma'lumotlarni yuklashda xatolik",
    empty: "Hozircha bu bo'limda grantlar yo'q",
    notFound: "Grant topilmadi",
    copied: "Havola nusxalandi",
    share: "Ulashish",
    apply: "Ariza berish",
    back: "Barcha grantlar",
    details: "Batafsil",
    related: "O'xshash grantlar",
    country: "Davlat",
  },
  ru: {
    pageTitle: "Гранты, проекты, меморандумы",
    tabGrants: "Гранты",
    tabProjects: "Проекты",
    tabMemorandums: "Меморандумы",
    heroTop: "Renessans",
    heroBottom: "Grants Projects",
    secMemorandums: "Меморандумы",
    secMemorandumsHint: "Соглашения о сотрудничестве нашего университета с зарубежными вузами и организациями.",
    secGrants: "Гранты и проекты",
    secGrantsHint: "Международные и национальные грантовые конкурсы, местные и международные проекты, возможности подачи заявок и результаты.",
    secResearch: "Научные исследования",
    secResearchHint: "Научные исследования, совместные проекты и научные результаты университета.",
    secExchange: "Академический обмен",
    secExchangeHint: "Международные программы мобильности, стажировки и возможности обмена для студентов и преподавателей.",
    moreInfo: "Подробнее",
    soon: "Скоро",
    partner: "Партнёр",
    date: "Дата",
    download: "Скачать документ",
    visitLink: "Перейти по ссылке",
    emptySection: "В этом разделе пока нет информации",
    otherItems: "Другие записи",
    students: "Студентам",
    teachers: "Преподавателям",
    universities: "Для вузов",
    everyone: "Для всех",
    studentsHint: "Стипендии и гранты на обучение",
    teachersHint: "Стажировки и исследовательские гранты",
    universitiesHint: "Институциональные проекты и партнёрство",
    chooseSection: "Для кого вы ищете грант?",
    grantCount: (n) => `Грантов: ${n}`,
    open: "Открыть",
    backToSections: "К разделам",
    international: "Международные",
    local: "Местные",
    funding: "Финансирование",
    deadline: "Дедлайн",
    daysLeft: (n) => `Осталось ${n} дн.`,
    lastDay: "Сегодня последний день",
    expired: "Срок истёк",
    noDeadline: "Срок не указан",
    loading: "Загрузка...",
    error: "Ошибка при загрузке данных",
    empty: "В этом разделе пока нет грантов",
    notFound: "Грант не найден",
    copied: "Ссылка скопирована",
    share: "Поделиться",
    apply: "Подать заявку",
    back: "Все гранты",
    details: "Подробнее",
    related: "Похожие гранты",
    country: "Страна",
  },
  en: {
    pageTitle: "Grants, projects, memorandums",
    tabGrants: "Grants",
    tabProjects: "Projects",
    tabMemorandums: "Memorandums",
    heroTop: "Renessans",
    heroBottom: "Grants Projects",
    secMemorandums: "Memorandums",
    secMemorandumsHint: "Cooperation agreements between our university and foreign higher education institutions and organizations.",
    secGrants: "Grants and projects",
    secGrantsHint: "International and national grant competitions, local and international projects, application opportunities and results.",
    secResearch: "Research",
    secResearchHint: "Research carried out at the university, joint projects and scientific results.",
    secExchange: "Academic exchange",
    secExchangeHint: "International mobility programs, internships and exchange opportunities for students and faculty.",
    moreInfo: "Learn more",
    soon: "Coming soon",
    partner: "Partner",
    date: "Date",
    download: "Download document",
    visitLink: "Open link",
    emptySection: "No information in this section yet",
    otherItems: "Other items",
    students: "For students",
    teachers: "For teachers",
    universities: "For universities",
    everyone: "For everyone",
    studentsHint: "Scholarships and study grants",
    teachersHint: "Fellowships and research grants",
    universitiesHint: "Institutional projects and partnerships",
    chooseSection: "Who are you looking for a grant for?",
    grantCount: (n) => `${n} grants`,
    open: "Open",
    backToSections: "Back to sections",
    international: "International",
    local: "Local",
    funding: "Funding",
    deadline: "Deadline",
    daysLeft: (n) => `${n} days left`,
    lastDay: "Last day today",
    expired: "Expired",
    noDeadline: "No deadline",
    loading: "Loading...",
    error: "Error loading data",
    empty: "No grants in this section yet",
    notFound: "Grant not found",
    copied: "Link copied",
    share: "Share",
    apply: "Apply",
    back: "All grants",
    details: "Details",
    related: "Similar grants",
    country: "Country",
  },
};

// URL slug <-> auditoriya qiymati
export const AUDIENCE_SLUGS = {
  students: "talabalarga",
  teachers: "oqituvchilarga",
  universities: "universitetlarga",
};
export const SLUG_TO_AUDIENCE = Object.fromEntries(
  Object.entries(AUDIENCE_SLUGS).map(([k, v]) => [v, k])
);
export const GRANTS_BASE = "/activity/ilmiy-faoliyat/grantlar-va-loyihalar";
// Grant bo'limlari (Talabalarga / O'qituvchilarga / OTMlar uchun) ko'rinishi
export const GRANTS_SECTIONS = `${GRANTS_BASE}?bolim=grantlar`;
export const audiencePath = (audience) =>
  AUDIENCE_SLUGS[audience] ? `${GRANTS_BASE}/${AUDIENCE_SLUGS[audience]}` : GRANTS_BASE;

// Memorandumlar / Ilmiy tadqiqotlar / Akademik almashinuv: API nomi -> URL slug va sarlavha kaliti
export const SECTION_PAGES = {
  memorandums: { slug: "memorandumlar", label: "secMemorandums" },
  research: { slug: "ilmiy-tadqiqotlar", label: "secResearch" },
  exchange: { slug: "akademik-almashinuv", label: "secExchange" },
};
export const sectionPath = (section, id) =>
  `${GRANTS_BASE}/${SECTION_PAGES[section].slug}${id ? `/${id}` : ""}`;

const MONTHS = {
  uz: ["Yan", "Fev", "Mar", "Apr", "May", "Iyun", "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek"],
  ru: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
};

export const normLang = (lang) => {
  const l = (lang || "uz").slice(0, 2);
  return LABELS[l] ? l : "uz";
};

export const getLabels = (lang) => LABELS[normLang(lang)];

// Tilga mos maydonni olish: item.title_ru bo'lmasa item.title_uz
export const pick = (item, field, lang) => {
  const l = normLang(lang);
  return item?.[`${field}_${l}`] || item?.[`${field}_uz`] || "";
};

// "30 Noy, 2026"
export const formatDate = (iso, lang) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const months = MONTHS[normLang(lang)];
  return `${d} ${months[m - 1]}, ${y}`;
};

// Bugundan oxirgi muddatgacha necha kun qolgani (o'tgan bo'lsa manfiy)
export const daysLeft = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  const deadline = new Date(y, m - 1, d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((deadline - today) / 86400000);
};

export const isExpired = (iso) => {
  const n = daysLeft(iso);
  return n !== null && n < 0;
};

// Bayroq rasmi (ISO kod bo'yicha)
export const flagUrl = (code) =>
  code ? `https://flagcdn.com/w40/${code.toLowerCase()}.png` : null;

// Rasm URL ni to'g'irlash (nisbiy bo'lsa)
export const imgUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return testUrl + (src.startsWith("/") ? "" : "/") + src;
};

// CKEditor HTML ichidagi rasm/havolalarni to'g'irlash (ActivityDetails bilan bir xil)
const fixSrc = (src) => {
  if (!src) return src;
  src = src.replace(/^(https?)\/\/([^/])/, "$1://$2");
  const doubleMatch = src.match(/https?:\/\/.+?(https?:\/\/.+)$/);
  if (doubleMatch) return doubleMatch[1];
  if (src.startsWith("/")) return testUrl + src;
  return src;
};

export const fixHtml = (html) => {
  if (!html) return "";
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    doc.querySelectorAll("img").forEach((img) => {
      img.setAttribute("src", fixSrc(img.getAttribute("src") || ""));
    });
    doc.querySelectorAll("a[href]").forEach((a) => {
      a.setAttribute("href", fixSrc(a.getAttribute("href") || ""));
    });
    return doc.body.innerHTML;
  } catch {
    return html;
  }
};

// Havolani nusxalash (Web Share bo'lsa — ulashish oynasi)
export const shareLink = async (url, title) => {
  try {
    if (navigator.share) {
      await navigator.share({ title, url });
      return "shared";
    }
  } catch {
    /* foydalanuvchi bekor qildi */
  }
  try {
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    const ta = document.createElement("textarea");
    ta.value = url;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    return "copied";
  }
};

// Saralash: yaqin muddatlilar oldin, muddatsizlar keyin, muddati o'tganlar oxirida
export const sortGrants = (list) =>
  [...list].sort((a, b) => {
    const da = daysLeft(a.deadline);
    const db = daysLeft(b.deadline);
    const rank = (n) => (n === null ? 1 : n < 0 ? 2 : 0);
    const ra = rank(da);
    const rb = rank(db);
    if (ra !== rb) return ra - rb;
    if (ra === 0) return da - db;
    if (ra === 2) return db - da;
    return 0;
  });
